import script from "./FloatNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatNotification.vue?vue&type=script&setup=true&lang=js"

import "./FloatNotification.vue?vue&type=style&index=0&id=64ea0e9c&lang=scss"

const __exports__ = script;

export default __exports__